import DOMPurify from "dompurify";

// Allowlist of tags/attributes suitable for product descriptions.
// Scripts, event handlers, iframes, forms, etc. are stripped by DOMPurify.
const CONFIG = {
  ALLOWED_TAGS: [
    "p", "br", "hr", "span", "div",
    "b", "strong", "i", "em", "u", "s", "strike", "sub", "sup", "small", "mark",
    "h1", "h2", "h3", "h4", "h5", "h6",
    "ul", "ol", "li",
    "blockquote", "pre", "code",
    "a", "img",
    "video", "source", "audio", "iframe",
    "table", "thead", "tbody", "tfoot", "tr", "th", "td",
  ],
  ALLOWED_ATTR: [
    "href", "target", "rel", "src", "alt", "title", "width", "height", "style", "class",
    "controls", "poster", "preload", "loop", "muted", "playsinline", "type",
    "allow", "allowfullscreen", "frameborder", "loading", "referrerpolicy",
  ],
  // Only allow safe URL schemes for href/src.
  ALLOWED_URI_REGEXP: /^(?:(?:https?|mailto|tel):|[^a-z]|[a-z+.-]+(?:[^a-z+.:-]|$))/i,
  // DOMPurify strips <iframe> by default even when allowlisted; opt it back in.
  ADD_TAGS: ["iframe"],
};

// Trusted hosts for <iframe> video embeds. Any iframe pointing elsewhere is
// removed during sanitization to avoid arbitrary-frame injection.
const ALLOWED_IFRAME_HOSTS = [
  "www.youtube.com",
  "youtube.com",
  "www.youtube-nocookie.com",
  "youtube-nocookie.com",
  "player.vimeo.com",
];

DOMPurify.addHook("afterSanitizeAttributes", (node) => {
  if (node.tagName === "IFRAME") {
    const src = node.getAttribute("src") || "";
    let ok = false;
    try {
      const url = new URL(src, window.location.origin);
      ok = url.protocol === "https:" && ALLOWED_IFRAME_HOSTS.includes(url.hostname);
    } catch (e) {
      ok = false;
    }
    if (!ok) {
      node.parentNode && node.parentNode.removeChild(node);
      return;
    }
    node.setAttribute("referrerpolicy", "no-referrer");
  }
});

// Force external links to be safe (noopener) after sanitization.
DOMPurify.addHook("afterSanitizeAttributes", (node) => {
  if (node.tagName === "A" && node.getAttribute("target") === "_blank") {
    node.setAttribute("rel", "noopener noreferrer");
  }
});

export const sanitizeHtml = (dirty) => {
  if (!dirty) return "";
  return DOMPurify.sanitize(String(dirty), CONFIG);
};

export default sanitizeHtml;
